// Use local calendar fields so Excel dates do not shift across time zones.
export const excelDateToISO = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const normalizeExcelDates = (row) => Object.fromEntries(
  Object.entries(row).map(([key, value]) => [key, value instanceof Date ? excelDateToISO(value) : value])
);

export const reportDateSuffix = (date = new Date()) =>
  date.toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit", year: "2-digit" }).replace(/\//g, "-");
